// @ts-ignore
export const isBun = typeof Bun !== 'undefined'
// @ts-ignore
export const isDeno = typeof Deno !== 'undefined'
